import { DtoBasket } from '@epicuro-next/data/baskets-dto';
import { isAfter } from '@epicuro-next/utilities';

export function isDtoBasketChecked(basket: DtoBasket) {
  return basket?.checkOrderExpiryUtc
    ? isAfter(new Date(basket.checkOrderExpiryUtc), new Date())
    : false;
}
